$(document).ready(function () {
  var preferredGrind = localStorage.getItem('preferredGrind');
  if (preferredGrind) {
    const selectInput = $('select[name*="grind" i]')

    $(`select[name*="grind" i], option[value="${preferredGrind}"]`)
      .prop('selected', true) //set select value to grind
      .get(0)
      // trigger and change won't work dispatch even triggers the custom elements code to change the underlying variant
      .dispatchEvent(new Event('change', { bubbles: true }));

    $(`label[for="${selectInput.attr("id")}"] span`).text(preferredGrind)
  }
});